import type { CropOption } from '@/app/components/shared/ImgCropModals/use-crop-options';

export const OFFLINE_AVATAR_CROP_OPTIONS: CropOption[] = [
  { label: '9:16', value: 9 / 16 },
  { label: '16:9', value: 16 / 9 },
  { label: '1:1', value: 1 },
  { label: '4:3', value: 4 / 3 },
  { label: '3:4', value: 3 / 4 },
];

export const OFFLINE_AVATAR_DEFAULT_CROP_RATIO = OFFLINE_AVATAR_CROP_OPTIONS[0].value;
